'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMAIL_PREFERENCE_CHECKLIST = undefined;

var _userConstants = require('../../../common/users/userConstants');

var EMAIL_PREFERENCE_CHECKLIST = exports.EMAIL_PREFERENCE_CHECKLIST = [{
    value: _userConstants.EMAIL_PREFERENCE_BITS.ACTIVITY_DIGEST,
    label: 'A daily summary of changes to boards you share'
}, { value: _userConstants.EMAIL_PREFERENCE_BITS.SHARED_BOARDS, label: 'An alert when someone shares a board with you' }, { value: _userConstants.EMAIL_PREFERENCE_BITS.PRODUCT_UPDATES, label: 'New feature announcements' }]; // Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/accountConstants.js
// module id = 751
// module chunks = 0